import { Section } from "./Primitives";
import { WordCycle } from "./Primitives";
import { FadeUp } from "./Reveal";
import { TICKER_1 } from "../../data/content";

export function TickerWords() {
  return (
    <Section id="ticker-1" className="py-24 md:py-36">
      <FadeUp>
        <p className="max-w-5xl font-display text-[1.75rem] font-light leading-[1.2] tracking-tight text-content sm:text-3xl md:text-4xl lg:text-5xl">
          {TICKER_1.prefix}{" "}
          <WordCycle words={TICKER_1.words} interval={2000} />
          <span className="text-mutedc">.</span>
        </p>
      </FadeUp>
    </Section>
  );
}
